import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./i18n";
import { quickExit } from "./components/QuickExit";
import Landing from "./pages/Landing";
import MapPage from "./pages/MapPage";
import Resources from "./pages/Resources";
import Admin from "./pages/Admin";

function App() {
  // Global safety: Esc key = instant exit to google
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") quickExit();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/map" element={<MapPage />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            borderRadius: "16px",
            border: "none",
            boxShadow: "0 12px 40px rgba(10,10,10,0.12)",
            color: "#2A2A2A",
          },
        }}
      />
    </LanguageProvider>
  );
}

export default App;
